import React from 'react';

const posts = [
  {
    id: 1,
    title: 'Claims software vs a product record',
    href: '/blog/claims-software-vs-product-record/',
    description: 'Claims software manages the complaint once it arrives. A product record knows the unit before anything goes wrong. Here is how to tell which one you need.',
    imageUrl: '/images/blog/v2/warranty-claim-automation-thumb.jpg',
    date: 'Oct 26, 2026',
    datetime: '2026-10-26',
    category: { title: 'Choosing a platform', href: '#' },
    readingTime: 4,
  },
  {
    id: 2,
    title: 'Why almost nobody registers your product',
    href: '/blog/warranty-registration-benefits/',
    description: 'Registration rates are low because the form asks the customer to do the manufacturer a favour. The fix is to make registration buy them something.',
    imageUrl: '/images/blog/v2/warranty-registration-benefits-thumb.jpg',
    date: 'Sep 2, 2026',
    datetime: '2026-09-02',
    category: { title: 'Warranty & product registration', href: '#' },
    readingTime: 4,
  },
  {
    id: 3,
    title: 'You do not know who has your products',
    href: '/blog/you-dont-know-who-has-your-products/',
    description: 'Most manufacturers have never spoken to the people who bought their products. The warranty gap is a relationship that never started.',
    imageUrl: '/images/blog/v2/you-dont-know-who-has-your-products-thumb.jpg',
    date: 'May 23, 2026',
    datetime: '2026-05-23',
    category: { title: 'Ownership, resale & product identity', href: '#' },
    readingTime: 8,
  }
];

export const BlogOverview: React.FC = () => {
  return (
    <section className="bg-white py-24 sm:py-32" aria-labelledby="blog-heading">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 id="blog-heading" className="text-4xl font-semibold tracking-tight text-balance sm:text-5xl" style={{ color: '#241E61' }}>
            From the blog
          </h2>
          <p className="mt-2 text-lg/8 text-gray-600">
            Insights on building better post-purchase experiences.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article key={post.id} className="flex flex-col items-start justify-between" itemScope itemType="https://schema.org/Article">
              <div className="relative w-full">
                <img
                  alt={`Featured image for ${post.title}`}
                  src={post.imageUrl}
                  className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover"
                  itemProp="image"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div className="flex max-w-xl grow flex-col justify-between">
                <div className="mt-6 flex items-center gap-x-4 text-xs">
                  <time dateTime={post.datetime} className="text-gray-500" itemProp="datePublished">
                    {post.date}
                  </time>
                  <span
                    className="rounded-full bg-gray-100 px-3 py-1.5 font-medium text-gray-600"
                    itemProp="articleSection"
                  >
                    {post.category.title}
                  </span>
                  <span className="text-gray-400">{post.readingTime} min read</span>
                </div>
                <div className="group relative grow">
                  <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600 transition-colors duration-200" itemProp="headline">
                    <a href={post.href}>
                      <span className="absolute inset-0" />
                      {post.title}
                    </a>
                  </h3>
                  <p className="mt-5 line-clamp-3 text-sm/6 text-gray-600" itemProp="description">
                    {post.description}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
        <div className="mt-16 flex justify-center">
          <a
            href="/blog/"
            className="rounded-md bg-white px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 transition-colors duration-200"
          >
            View all blog posts
          </a>
        </div>
      </div>
    </section>
  );
};